import type { FC } from "react";

import { Button, Overlay, Stack, Text } from "@mantine/core";
import { IconDeviceUnknown } from "@tabler/icons-react";

import sharedStyles from "@/common-ui/sharedStyles.module.css";

interface Props {
    onRetry: () => void;
}

export const EvaluationRetryOverlay: FC<Props> = ({ onRetry }) => (
    <Overlay data-testid="evaluation-retry-overlay" color="var(--exwo-color-app-bg)" backgroundOpacity={1} zIndex={401}>
        <Stack align="center" justify="center" h="100%" gap="1.5rem" className={sharedStyles.animateScaleIn}>
            <IconDeviceUnknown size={80} stroke={1.5} />
            <Stack gap="0.25rem">
                <Text fw="700" ta="center" size="xl">
                    There was an issue loading your results.
                </Text>
                <Text fw="700" ta="center" size="xl">
                    Clicking below will re-evaluate your session and retrieve your score.
                </Text>
                <Text fw="700" ta="center" size="xl">
                    This will not restart your simulation.
                </Text>
            </Stack>
            <Button data-testid="retry-evaluation-button" onClick={onRetry}>
                Retry
            </Button>
        </Stack>
    </Overlay>
);
